import { Bigdelta } from '../client';

(window as any).Bigdelta = Bigdelta;
